import { render } from "./App.vue?vue&type=template&id=55990001"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=55990001&lang=scss"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__